import router from './router'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import { constantRoutes } from './router'

NProgress.configure({ showSpinner: false })

// 不重定向白名单
const whiteList = ['/login']

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  const token = getToken() // 获取 token (身份验证)

  if (token) {
    // 如果 token 存在，表示用户已登录
    if (to.path === '/login') {
      // 如果用户已登录，且访问的是登录页面，重定向到首页
      next({ path: '/' })
      NProgress.done()
    } else {
      next()
      try {
        // // 获取用户信息，包括用户权限（如可访问的路由）
        // const { data } = await store.dispatch('user/getInfo')

        // // 假设接口返回的是一个包含路由信息的对象
        // // 你可以根据返回的数据动态生成路由配置
        // const accessRoutes = data.routes // 假设接口返回的权限信息中包含 routes

        // // 动态添加可访问的路由（逐个添加）
        // accessRoutes.forEach(route => {
        //   router.addRoute(route) // 使用 addRoute 添加单个路由
        // })

        // // 重新尝试导航到目标路由（确保新添加的路由生效）
        // next({ ...to, replace: true })
      } catch (error) {
        // 如果获取用户信息失败，清除 token 并跳转到登录页
        // await store.dispatch('user/resetToken')
        Message.error(error.message || '发生错误')
        next(`/login?redirect=${to.path}`)
        NProgress.done()
      }
    }
  } else {
    // 如果没有 token，跳转到登录页
    if (whiteList.includes(to.path)) {
      // 如果是白名单中的路由（如登录页），允许访问
      next()
    } else {
      // 否则，跳转到登录页，并附带 redirect 参数，登录后可以跳回原路由
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // 完成路由导航后结束进度条
  NProgress.done()
})
